import firebase from "../../firebase";

export default function({ officeId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "getInvoiceEstimates",
        data: { officeId: officeId }
    });
}
